import { useEffect, useState } from 'react';
import '/assets/styles/pages/menu-category.scss';

// Sections
import MenuHeader from '/views/sections/menu-header';

// Partials
import Loader from '/views/partials/loader';
import Pricebox from '/views/partials/pricebox';
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Services
import menuServices from '/services/menu';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from '/utilities/i18n';

const MenuCategory = () => {
	const { selectedBranch, initialized } = useBranchSelection();
	const { id: categoryId } = useParams('menuCategory');
	const { openModal } = useModals();
	const { redirect } = useNavigator();
	const [category, setCategory] = useState(null);
	const { t } = useTranslation();

	useEffect(() => {
		setCategory(null);
		if (selectedBranch && categoryId) {
			menuServices
				.getMenuCategory(selectedBranch.slug, categoryId)
				.then((payload) => {
					setCategory(payload);
				})
				.catch((feedback) => {
					redirect('home');
					openModal('message', { feedback });
				});
		} else if (initialized && !selectedBranch) {
			redirect('placeOrder');
		}
	}, [categoryId, selectedBranch, initialized]);

	return (
		<>
			<MenuHeader title={category?.title ?? false} backLink="menu" backLinkRedirect hideSearch />
			<div className="category-container loader-container">
				<Loader dark loading={!category} />
				{category?.products && (
					<>
						<div className="category-products wrapper">
							{category.products.map((product) => (
								<Link
									className="products-product"
									href="menuProduct"
									params={{ id: product.id }}
									key={product.id}
								>
									<div className="product-imagewrap">
										<Img src={product.image} className="product-image" />
									</div>
									<div className="product-textarea">
										<strong className="product-title">{product.title}</strong>
										<Pricebox className="product-price" colored product={product} />
									</div>
								</Link>
							))}
						</div>
						<div className="category-updatedate wrapper">
							{t('Fiyat güncellenme tarihi')}: <strong>{category.updated_at_formatted}</strong>
						</div>
					</>
				)}
			</div>
		</>
	);
};

export default MenuCategory;
